export default "__VITE_ASSET__NT8HwkHW__"